import axios from 'axios';

// Configure global Axios instance.
// Base URL comes from env (REACT_APP_DATABASEURL, e.g. https://ncet.co.in/ or
// http://localhost:4001/) with any trailing slash stripped, since the route
// constants already start with `/api/...`. Falls back to localhost for dev.
const API_BASE = (
  process.env.REACT_APP_DATABASEURL ||
  process.env.REACT_APP_BACKEND_URL ||
  'http://localhost:4001'
).replace(/\/+$/, '');

const httpCommon = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request Interceptor
httpCommon.interceptors.request.use(
  (config) => {
    // You can attach tokens here if needed in the future
    // const token = localStorage.getItem('token');
    // if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
httpCommon.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default httpCommon;
